import React, { SVGAttributes } from "react";

interface Props extends SVGAttributes<SVGElement> {}

const IconCalculator: React.FC<Props> = (props) => {
  return (
    <svg viewBox="0 0 512 512" {...props}>
      <g fill="currentColor">
        <path
          d="M448,0H64C46.368,0,32,14.368,32,32v448c0,17.664,14.368,32,32,32h384c17.664,0,32-14.336,32-32V32
			C480,14.368,465.664,0,448,0z M160,448H96v-64h64V448z M160,320H96v-64h64V320z M288,448h-64v-64h64V448z M288,320h-64v-64h64V320
			z M416,448h-64V256h64V448z M416,176c0,8.832-7.168,16-16,16H112c-8.832,0-16-7.168-16-16V80c0-8.832,7.168-16,16-16h288
			c8.832,0,16,7.168,16,16V176z"
        />
      </g>
    </svg>
  );
};

export default IconCalculator;
